import axios from 'axios';
// prod
export const API_URI = 'https://api.amorc.org.br/v1/';
// export const API_URI = 'https://apiteste.amorc.org.br/v1/';


class Api {
  constructor() {
    const instance = axios.create({
      baseURL: API_URI,
      headers: {
        // prod
        Authorization: 'Basic ODptSFU5SXNzeEpJanlGT0VBOFZzZ3FmYmFPUzY5a3hudWRoNDV3aEdS',
        // Authorization: 'Basic MzplUm1CdFN4Mlo4ZlhVZDUzTWl4RWtFaWZxYklFWGNIRGpsUDdoZkVz',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    return instance;
  }
}

export default new Api();
